module.exports = __webpack_public_path__ + "static/media/icon_setting.8cd3d80e.svg";